var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[(
      _vm.imagem !== null &&
        _vm.imagem !== undefined &&
        _vm.imagem != 'none' &&
        _vm.imagem != ''
    )?_c('img',{staticClass:"photo",attrs:{"src":_vm.imagem},on:{"click":function($event){return _vm.emitHandle()}}}):_c('img',{staticClass:"photo",attrs:{"src":_vm.imagemStatic},on:{"click":function($event){return _vm.emitHandle()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }